<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-04-30 20:59:55
 * @LastEditors: ???
 * @LastEditTime: 2022-05-28 23:35:34
-->
<template>
  <div class="wrapper orderAmount">
    <div class="search_wrap">
      <el-form :model="queryParam" ref="form" label-width="80px" :inline="true" size="mini">
        <el-form-item label="创建时间">
          <el-date-picker
            style="width: 350px"
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="dateRangeChange"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
          <el-button type="primary" @click="handleExportXls('预约量-街道订单')">街道订单导出</el-button>
          <el-button type="primary" @click="handleExportXls('预约量-社区订单', url.exportXlsUrl2)">社区订单导出</el-button>

          <!-- <el-button size="mini" type="primary" @click="handleAdd()"
            >新增</el-button
          >-->
          <!-- <el-button type="danger" @click="batchDel">批量删除</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="summary">
      <div class="summary_box">
        <p>{{ summaryData.newCount }}</p>
        <p>新订单</p>
      </div>
    </div>
    <div class="summary">
      <div class="summary_box">
        <p>{{ summaryData.doingCount }}</p>
        <p>进行中</p>
      </div>
    </div>

    <div class="summary">
      <div class="summary_box">
        <p>{{ summaryData.compleCount }}</p>
        <p>已完成</p>
      </div>
    </div>

    <div class="summary">
      <div class="summary_box">
        <p>{{ summaryData.cancelCount }}</p>
        <p>已取消</p>
      </div>
    </div>

    <e-table
      :lazy="true"
      :listLoading="loading"
      :load="loadCommunity"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="
        dataSource.map((item) => {
          item.hasChildren = true;
          item.mine_id = randomUUID();
          return item;
        })
      "
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #faceUrl="slotData">
        <!-- <el-avatar
          :size="50"
          shape="square"
          :src="getAvatar(slotData.data.row.faceUrl)"
          @error="return true;"
          fit="fill"
        >-->

        <!-- <span v-if="!getAvatar(slotData.data.row.faceUrl)">未上传</span>
        <img
          style="width: 60px; height: 60px"
          v-if="getAvatar(slotData.data.row.faceUrl)"
          :src="slotData.data.row.faceUrl"
        />-->
        <!-- </el-avatar> -->

        <el-image
          v-if="getAvatar(slotData.data.row.faceUrl)"
          :src="getAvatar(slotData.data.row.faceUrl)"
          :preview-src-list="[...getAvatar(slotData.data.row.faceUrl)]"
          style="width: 60px; height: 60px"
        >
          <div slot="placeholder" class="image-slot">
            加载中
            <span class="dot">...</span>
          </div>
        </el-image>
        <span v-else>未上传</span>
      </template>
      <template #handlerSlot="slotData">
        <el-button size="mini" @click="handleEdit(slotData.data.row)">修改</el-button>
        <el-button type="danger" size="mini" @click="handleDelete(slotData.data.row.id)">删除</el-button>
      </template>
    </e-table>

    <modal-form ref="modalForm" @ok="modalFormOk"></modal-form>
  </div>
</template>

<script>
import modalForm from "./component/addModal"
import eTable from "@/components/table"
import { listMixin } from "@/mixins/listMixin"
import { getCommunityDataByStreetId, getOrderAmountSummary } from "@/api/order"
import { getLast7Days, randomUUID } from "@/utils/util"

export default {
  components: { eTable, modalForm },
  mixins: [listMixin],
  props: {},
  data () {
    return {
      summaryData: [],
      dateRange: [],
      deleteKey: "userId",
      url: {
        list: "/community/statistical/street/bookingOrder",
        exportXlsUrl: "community/statistical/street/bookingOrder/export",
        exportXlsUrl2: "community/statistical/community/bookingOrder/export",
      },

      //字段权限
      columns: [
        { field: "id", label: "编号" },

        { field: "name", label: "街道" },

        { field: "newCount", label: "新订单" },
        { field: "doingCount", label: "进行中" },

        {
          field: "compleCount",
          label: "已完成",
        },
        {
          field: "cancelCount",
          label: "已取消",
        },
      ],
    }
  },
  watch: {},
  computed: {},
  methods: {
    randomUUID,
    searchReset () {
      this.queryParam = {
        status: '0',
      }
      this.initDictConfig()
      this.loadData(1)
    },
    initDictConfig () {
      this.dateRange = getLast7Days()
      this.dateRangeChange(this.dateRange)
    },
    loadCommunity (tree, treeNode, resolve) {
      let data = {
        streetId: tree.id,
        beginTime: this.queryParam.beginTime,
        endTime: this.queryParam.endTime,
        pageNo: 1,
        pageSize: 99,
      }

      getCommunityDataByStreetId(data).then((res) => {
        console.log(res)
        if (res.code == 200) {
          let temp = res.data.map((item) => {
            item.mine_id = randomUUID()
            return item
          })
          resolve(temp || [])
        } else {
          resolve([])
        }
      })
    },
    loadOtherData (params) {
      getOrderAmountSummary(params).then((res) => {
        this.summaryData = res.data
      })
    },
    dateRangeChange (val) {
      console.log(val)
      if (val) {
        this.queryParam.beginTime = val[0]
        this.queryParam.endTime = val[1]
      } else {
        this.queryParam.beginTime = ''
        this.queryParam.endTime = ''
      }
    },
    fetchData () {
      console.log(this.ipagination.page)
    },
    add (val) {
      console.log(val)
    },
    edit (val) { },
    del (val) { },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  v-deep.el-table__row--level-1 {
    background: #cbcecb !important;
    .el-table__cell {
      background: #cbcecb !important;
    }
  }
}
</style>
